import { useFocusTrap as useFocusTrapWeb } from '@dce-front/onewebapp-util-react';

const useFocusTrapTv = (): void => {};

export const useFocusTrap = $_BUILD_RENDERMODE_CSR
  ? useFocusTrapTv
  : useFocusTrapWeb;
